"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgSprite = SvgSprite;
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = require("prop-types");
const classnames_1 = __importDefault(require("classnames"));
const svg_sprite_module_scss_1 = __importDefault(require("./svg-sprite.module.scss"));
function SvgSprite({ spriteID, spriteSheetPath = '/static/assets/svg-icons/svg-sprite.svg', className, dataSelector = `svgSprite--${spriteID}` }) {
    if (!spriteID)
        return null;
    const svgSpriteSheetPath = `${spriteSheetPath}#${spriteID}`;
    const svgContainerClasses = (0, classnames_1.default)(svg_sprite_module_scss_1.default.svg, className, {
        [svg_sprite_module_scss_1.default['svg--small']]: spriteID.includes('small'),
        [svg_sprite_module_scss_1.default['svg--fill']]: spriteID.includes('fill'),
    });
    const spriteClasses = (0, classnames_1.default)(svg_sprite_module_scss_1.default.svgSprite);
    /*
    Non-standard svgs will sometimes have specific styling requirements in the svg file.
    The svg type specific styles do not transfer from the sprite to the component, so default classes were created to match the intended styling.
    If there are new svg types being added, a default class should be added to create the base styling.
    These Type classifications and their respective styling should not be removed or changed unless directed by the Design team.
    */
    let svgType = 'standard';
    switch (true) {
        case spriteID.includes('small'):
            svgType = 'small';
            break;
        case spriteID.includes('fill'):
            svgType = 'fill';
            break;
        default:
            svgType = 'standard';
    }
    return ((0, jsx_runtime_1.jsx)("svg", { "data-selector": dataSelector, "data-style-svgtype": svgType, className: svgContainerClasses, children: (0, jsx_runtime_1.jsx)("use", { href: svgSpriteSheetPath, "data-style-id": spriteID, className: spriteClasses }) }));
}
SvgSprite.propTypes = {
    /** The id of the sprite to render as well as for custom styling */
    spriteID: prop_types_1.string.isRequired,
    /** Option to pass a relative path to a specific spritesheet. By default, the storefront svg spritesheet from the Storefront Assets repository is used.
     * If a different path is used: the loaded svg spritesheet must be from the same domain where the sprites are being rendered */
    spriteSheetPath: prop_types_1.string,
    /** Add a custom className for additional styling of the SvgSprite svg element */
    className: prop_types_1.string,
    /** A unique id attached to the 'data-selector' attribute that allows for easy DOM querying by third party tools */
    dataSelector: prop_types_1.string
};
//# sourceMappingURL=svg-sprite.js.map